import type { PivotSelectionStats, PivotSelectionValue } from './types'

/** Counts and totals the numeric cells of a selection — labels, blanks and non-finite numbers never count. */
export const computePivotSelectionStats = (values: PivotSelectionValue[]): PivotSelectionStats => {
  let count = 0
  let sum = 0
  values.forEach((value) => {
    if (typeof value === 'number' && Number.isFinite(value)) {
      count += 1
      sum += value
    }
  })
  return { count, sum, average: count ? sum / count : 0 }
}
